import React from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const TermsCondition = () => {
  return (
    <>
      <Navbar />
      <div className="terms-condition">
      <div className="terms-condition-main">
  <div className="terms-condition-contain gCDmxv">
    <h1
      className="terms-condition-h1"
     
    >
      Terms &amp; Conditions
    </h1>
    <p  className="terms-condition-para f-size">
    Kalyan, Main Bazar Jodi Chart Satta Matka Record Old History Historical Data
      Bracket Results Chart Online Live Book Digits Numbers
    </p>
  </div>
</div>

<div className="terms-condition-second-main">
    
<div className="gCDmxv kDBKpC">
          <h1 className="h1-fw-600">Withdraw Information</h1>
          <ul>
            <li>
              <span className="span-tag-color">●</span>
              <p  className='f-size'>
                If Users Entered Wrong Bank Details Khatri555 Is Not
                Responsible.
              </p>
            </li>
            <li>
              <span className="span-tag-color">●</span>
              <p  className='f-size'>Before Requesting Withdraw Re-check Your Bank Details.</p>
            </li>
            <li>
              <span className="span-tag-color">●</span>
              <p  className='f-size'>
                After Withdraw Request If There Is No Vaild Wallet Balance The
                Request Will Be Auto Declined.
              </p>
            </li>
          </ul>
        </div>
        <div className="gCDmxv kDBKpC">
  <h1 className="h1-fw-600">Unfair - Bets</h1>
  <p  className='f-size'>
    If Admin Found Any Unfair-bets, Blocking Of Digits, Canning Or Match Fix
    Bets. Admin Has All Rights To Take Necessary Actions To Block The User.
  </p>
</div>
<div className="gCDmxv kDBKpC">
  <h1 className="h1-fw-600 ">Cheating - Bets</h1>
  <p  className='f-size'>
    If Admin Found Any Cheating, Hacking, Phishing. Admin Has All Rights To Take
    Necessary Actions To Block The User.
  </p>
</div>

</div>

      </div>
      <Footer />
    </>
  );
};

export default TermsCondition;
